import { z } from 'zod';
import { defineListQuery, listFilter } from './list-query.schemas';

/** GPS webhook and polling ingestion (gitaumoses4/chukua#85): raw deliveries, their processing outcome, and replay. */

const instantSchema = z.iso.datetime({ offset: true });

/** A device an installation delivered events for, with no mapping to a truck — surfaced so an admin can add one. */
export interface UnmappedDevice {
  integrationId: string;
  integrationName: string;
  deviceId: string;
  eventCount: number;
  firstSeenAt: string;
  lastSeenAt: string;
}

export const unmappedDeviceListQuerySchema = defineListQuery({
  sortFields: ['deviceId', 'eventCount', 'firstSeenAt', 'lastSeenAt'],
  defaultSort: { sort: 'lastSeenAt', order: 'desc' },
  filters: { integrationId: listFilter(z.uuid()) },
});
export type UnmappedDeviceListQuery = z.infer<typeof unmappedDeviceListQuerySchema>;

/** Reprocesses what an installation already received; it does not go back to the vendor. */
export const replayRawEventsInputSchema = z
  .object({ from: instantSchema, to: instantSchema })
  .refine((value) => value.from <= value.to, { message: 'from must not be after to', path: ['to'] });
export type ReplayRawEventsInput = z.infer<typeof replayRawEventsInputSchema>;

export interface ReplayRawEventsResult {
  from: string;
  to: string;
  /** Raw events looked at, not just the ones that newly dispatched: a replay over an already-processed window is still a 200. */
  count: number;
}
